import axios from 'axios'
import { SERVER_SENGRID } from '@env'
const axiosInstance = axios.create({ baseURL: `${SERVER_SENGRID}` })
export default axiosInstance
